const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/documents/$documentId.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/documents/$documentId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});